<template>
	<page-content-layout class="tracking" title="Tracking">
		<!--<btn slot="tools" label="Geofencing" @click="geofencingButtonClick" />-->
		<full-icon-button-view slot="tools" icon="history" @click="history.open = !history.open" />
		<full-icon-button-view slot="tools" icon="fit" @click="fitButtonClick" />
		<button-view class="desktop" slot="tools" label="Køretøjer" @click="vehiclesButtonClick" />
		<full-icon-button-view class="mobile" slot="tools" icon="truck" @click="vehiclesButtonClick" emphasis="primary" />
		<gmap-map class="tracking__map" ref="map" :center="center" :zoom="zoom" :options="mapOptions">
			<!--<gmap-marker :key="index" v-for="(vehicle, index) in vehicles" :position="vehicle.position" :icon="{
				url: vehicle.state && vehicle.data.heartbeat <= 5 ? (vehicle.state.event == 'stop' ? markerIcons.parked : markerIcons.moving[vehicle.direction]) : markerIcons.error, 
	
				//size: {width: 41, height: 51, f: 'px', b: 'px'}, 
				scaledSize: {width: 20, height: 20, f: 'px', b: 'px'}
				//labelOrigin: {x: 0, y: -15},
				//labelClass: 'tracking-label'
			}" :label="{
				text: vehicle.data.label,
				color: '#000',
				fontSize: '14px'
			}" @click="vehicleMarkerClick(vehicle.data.id)" />-->
			<gmap-custom-marker :key="index" v-for="(vehicle, index) in orderedVehicles" :marker="vehicle.position" @click.native="vehicleMarkerClick(vehicle.data.id)">
				<svg-marker :type="(vehicle.state && vehicle.data.duration <= 5 * 60) ? (vehicle.state.event == 'stop' ? 'parked' : 'driving') : 'error'" :angle="vehicle.data.angle" :label="vehicle.data.label" />
			</gmap-custom-marker>

			<gmap-custom-marker :key="index" v-for="(event, index) in _events" :marker="event.position">
				<svg-marker :type="{
					start: 'driving',
					stop: 'parked',
					enter: 'blue',
					leave: 'green'
				}[event.event]" :label="$options.filters.extractTime(event.logged)" />
			</gmap-custom-marker>

			<gmap-polyline v-bind:path.sync="_poly" v-bind:options="{ strokeColor:'#f7223f'}" />
		</gmap-map>
		<div :class="{
			'tracking-history': true,
			hidden: !history.open
		}">
			<div class="title">Historik</div>
			<svgicon class="close" icon="close" @click="history.open = false" />
			<select-view class="ctrl gray" label="Køretøj" v-model="history.vehicle_id" :options="_sortedVehicles" optionValueName="id" optionLabelName="name" />
			<date-select-view class="gray ctrl" label="Dato" v-model="history.from_date" :controller="$store.state.popupController" />
			<div class="line ctrl">
				<clock-select-view label="Fra" class="gray" v-model="history.from_time" :controller="$store.state.popupController" />
				<clock-select-view label="Til" class="gray" v-model="history.to_time" :controller="$store.state.popupController" />
			</div>
		</div>
	</page-content-layout>
</template>

<script>
	import GmapCustomMarker from 'vue2-gmap-custom-marker';

	import SvgMarker from '../SvgMarker'

	import VehicleWindow from '../windows/VehicleWindow'
	import TrackingVehiclesWindow from '../windows/TrackingVehiclesWindow'

	//import MarkerVehicle from '@/assets/images/marker-vehicle.png'
	import MarkerParked from '@/assets/images/tracking-marker-parked.png'
	import MarkerError from '@/assets/images/tracking-marker-error.png'

	import MarkerMovingN from '@/assets/images/tracking-marker-moving-n.png'
	import MarkerMovingNE from '@/assets/images/tracking-marker-moving-ne.png'
	import MarkerMovingE from '@/assets/images/tracking-marker-moving-e.png'
	import MarkerMovingSE from '@/assets/images/tracking-marker-moving-se.png'
	import MarkerMovingS from '@/assets/images/tracking-marker-moving-s.png'
	import MarkerMovingSW from '@/assets/images/tracking-marker-moving-sw.png'
	import MarkerMovingW from '@/assets/images/tracking-marker-moving-w.png'
	import MarkerMovingNW from '@/assets/images/tracking-marker-moving-nw.png'
	/*import PassiveVehicleMarker from '@/assets/images/marker-vehicle-yellow.png'
	import ActiveVehicleMarker from '@/assets/images/marker-vehicle-green.png'*/

	import SelectView from '../views/SelectView';
	import DateSelectView from '../views/DateSelectView';

	import { bus } from '../../bus'

    export default {
		methods: {
			geofencingButtonClick() {
				

				//this.zoom = 1;
			},
			vehiclesButtonClick() {
				

				this.$store.state.windowStack.push(TrackingVehiclesWindow, {onChange: function () {
					//contacts.update();
					//
				}});

				

				/*this.center = {
					lat: 55.679325,
					lng: 12.60263
				};*/
			},
			vehicleMarkerClick(id) {
				//

				this.$store.state.windowStack.push(VehicleWindow, {id: id, form: true, onChange: function () {
					//contacts.update();
					//
				}});
			},
			fitButtonClick() {
				var small	= {lat: 1000000, lng: 1000000};
				var large	= {lat: -1000000, lng: -1000000};	


				var bounds = new google.maps.LatLngBounds();


				
				for (var i = 0; i < this.vehicles.length; ++i) {
					for (var j = 0; j < this.vehicles[i].data.records.length; ++j) {
						if (small.lat > this.vehicles[i].data.records[j].lat) small.lat = this.vehicles[i].data.records[j].lat;
						if (small.lng > this.vehicles[i].data.records[j].lng) small.lng = this.vehicles[i].data.records[j].lng;
						if (large.lat < this.vehicles[i].data.records[j].lat) large.lat = this.vehicles[i].data.records[j].lat;
						if (large.lng < this.vehicles[i].data.records[j].lng) large.lng = this.vehicles[i].data.records[j].lng;
					}

					bounds.extend(this.vehicles[i].position);
				}

				
				

				small.lat = parseFloat(small.lat);
				small.lng = parseFloat(small.lng);
				large.lat = parseFloat(large.lat);
				large.lng = parseFloat(large.lng);

				this.$refs.map.$mapObject.fitBounds(bounds);
			},
			render() {
				//

				var d = new Date();
				var t = d.getTime() - this.delay;
				var coef;

				for (var i = 0; i < this.vehicles.length; ++i) {
					var t1 = 0;
					var rec1 = null;
					var rec2 = null;

					for (var j = 0; j < this.vehicles[i].data.records.length; ++j) {
						if (this.vehicles[i].data.records[j].logged >= t) {
							//t2 = this.vehicles[i].data.records[j].logged;
							rec2 = this.vehicles[i].data.records[j];
						}

						if (this.vehicles[i].data.records[j].logged < t && t1 == 0) {
							t1 = this.vehicles[i].data.records[j].logged;
							rec1 = this.vehicles[i].data.records[j];
						}
					}

					// No new data
					if (rec1 === null) rec1 = rec2;
					if (rec2 === null) rec2 = rec1; 

					// Calculate position between points, if coef == 0, then the trackign data is too old
					coef = rec1.logged == rec2.logged ? 0 : ((t - rec1.logged) / (rec2.logged - rec1.logged));

					this.vehicles[i].active = coef != 0;

					this.vehicles[i].position = {
						lat: parseFloat(rec1.lat) + coef * (parseFloat(rec2.lat) - parseFloat(rec1.lat)),
						lng: parseFloat(rec1.lng) + coef * (parseFloat(rec2.lng) - parseFloat(rec1.lng)),
					};
				}

				this.renderHandle = setTimeout(() => {
					this.render();
				}, 30);
			},
			poll() {
				var page = this;

				this.axios
					.get('/tracking/status/')
					.then(function (r) {
						//
						var match;

						for (var i = 0; i < r.data.length; ++i) {
							match = false;

							for (var j = 0; j < page.vehicles.length; ++j) {
								if (r.data[i].id == page.vehicles[j].data.id) {
									match = true;

									// Update vehicle
									page.vehicles[j].data = r.data[i];
									page.vehicles[j].state = r.data[i].state;
									
								}
							}

							if (!match) {
								// Add vehicle
								page.vehicles.push({
									id: r.data[i].id,
									name: r.data[i].label,
									active: true,
									direction: 'n',
									data: r.data[i],
									position: null,
									state: r.data[i].state
								});
							}
						}



						
					});

				this.pollHandle = setTimeout(() => {
					//this.$store.dispatch('RETRIEVE_DATA_FROM_BACKEND')
					this.poll();
				}, 1000 * 30);
			},
			update() {
				this.vehicles = [];

				clearInterval(this.pollHandle);
				clearInterval(this.renderHandle);

				this.poll();
				this.render();
			}
		},
		created: function () {
			this.poll();
			this.render();
		},
		beforeDestroy: function () {
			clearInterval(this.pollHandle);
			clearInterval(this.renderHandle);
		},
		watch: {
			history: {
				deep: true,
				async handler() {
					// Always clear
					this.route = [];

					if (this.history.open && this.history.vehicle_id) {
						var from = this.history.from_date + ' ' + this.history.from_time;
						var to =  this.history.from_date + ' ' + this.history.to_time;
						var r = await this.axios.get('/fleet/vehicles/' + this.history.vehicle_id + '/route/?from=' + from + '&to=' + to);

						this.route = r.data;
					}
				}
			}
		},
		data: function () {
			return {
				route: [],
				history: {
					open: false,
					vehicle_id: null,
					from_date: (new Date()).format('Y-m-d'),
					to_date: (new Date()).format('Y-m-d'),
					from_time: '00:00',
					to_time: '24:00'
				},

				svg: '<svg width="400" height="110"><rect width="300" height="100" /></svg>',
				delay: 150 * 1000,
				pollHandle: null,
				renderHandle: null,
				zoom: 12,
				center: {
					lat: 55.679325,
					lng: 12.6026383
				},
				vehicles: [],
				markerIcons: {
					parked: MarkerParked,
					error: MarkerError,
					moving: {
						n: MarkerMovingN,
						ne: MarkerMovingNE,
						e: MarkerMovingE,
						se: MarkerMovingSE,
						s: MarkerMovingS,
						sw: MarkerMovingSW,
						w: MarkerMovingW,
						nw: MarkerMovingNW,
					}
				},
				mapOptions:  {
					disableDefaultUI: false
				}
			}
		},
		components: {
			gmapCustomMarker: GmapCustomMarker,
			svgMarker: SvgMarker,
			selectView: SelectView,
			dateSelectView: DateSelectView
		},
		mounted: function () {
			this.axios.put('/activity/map/');

			this.$refs.map.$mapPromise.then((/*m*/) => {
				//m.panTo({lat: 1.38, lng: 103.80})
			})

			this.update();

			var self = this;

			bus.$on('update', function () {
				self.update();
			});

			bus.$on('clear', function () {
				self.vehicles = [];
				self.route = [];
			});


			/*this.axios
				.all([
					this.axios.get('/contacts/'),
					this.axios.get('/contacts/columns/')
				]).then(function (results) {
					
				});*/
		},
		beforeRouteLeave(to, from, next) {
			bus.$off('update');
			bus.$off('clear');

			next();
		},
		computed: {
			_events() {
				var r = [];

				for (var i = 0; i < this._route.length; ++i) {
					if (this._route[i].event !== null) {
						r.push(this._route[i]);
					}
				}

				return r;
			},
			_route() {
				var r = [];

				if (this.history.open) {
					for (var i = 0; i < this.route.length; ++i) {
						r.push({
							...this.route[i],
							position: {
								lat: parseFloat(this.route[i].lat),
								lng: parseFloat(this.route[i].lng)
							}
						});
					}
				}

				return r;
			},
			_poly() {
				return this._route.map(function (item) {
					return item.position;
				});
			},
			_sortedVehicles() {
				var r = Array.from(this.vehicles);

				r.sort(function (a, b) {
					var n1 = a.name.toString().toLowerCase();
					var n2 = b.name.toString().toLowerCase();

					if (n1 < n2) return -1;
					if (n1 > n2) return 1;
					return 0;
				});

				return r;
			},
			orderedVehicles() {
				if (this.history.open) {
					return [];
				}

				var v = Array.from(this.vehicles);

				v.sort(function (a, b) {
					return a.position && b.position ? b.position.lat - a.position.lat : 0;
				});

				return v;
			}
		}
    }
</script>

<style lang="scss" scoped>
	.tracking {
		

		& .page__content__content {
			overflow: hidden;
		}

		& .desktop {
			display: block;
		}

		& .mobile {
			display: none;
		}

		&__map {
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
			height: 100%;
		}

		& .tracking-history {
			position: absolute;
			left: 20px;
			bottom: 20px;
			background-color: white;
			width: 300px;
			border-radius: 5px;
			padding: 20px;
			transition: transform .2s, opacity .2s, visibility .2s;
			opacity: 1;
			visibility: visible;

			& > .close {
				width: 16px;
				height: 16px;
				position: absolute;
				right: 20px;
				top: 20px;
				fill: black;
				cursor: pointer;
			}

			& > .line {
				display: grid;
				grid-template-columns: 1fr 1fr;
				column-gap: 10px;
			}

			& > .ctrl {
				margin-top: 10px;
			}

			&.hidden {
				opacity: 0;
				visibility: hidden;
				transform: translateX(-50px);
			}
		}
	}

	.tracking-label {
		background-color: black;
	}

	@media only screen and (max-width: 600px ) {
		.tracking {
			& .desktop {
				display: none;
			}

			& .mobile {
				display: block;
			}
		}
	}
</style>